import { mapGetters, mapActions } from "vuex";
import EventBus from "@/eventBus";

export const fetchAllMixin = {
  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"])
  },
  methods: {
    ...mapActions("pages", ["setPageLoaded", "setPageLoading"]),
    async toFetchOrNotToFetch(vm, page, options = { force: false }) {
      const { force } = options;
      //===========================
      // Parent Component Must Implement:
      // vm.fetchAllPage
      // vm.isPageLoading (vuex getter)
      // vm.isPageLoaded (vuex getter)
      // vm.setPageLoaded (vuex action)
      // vm.setPageLoading (vuex action)
      // ==========================
      if ((!vm.isPageLoaded(page) && !vm.isPageLoading(page)) || force) {
        vm.setPageLoading({ key: page, value: true });
        // note: using try/catch here catches errors the .then throws if a logout event occurs
        try {
          await vm.fetchAllPage(vm, page);
          vm.setPageLoaded({ key: page, value: true });
          vm.setPageLoading({ key: page, value: false });
          EventBus.emitPageLoadedMyDashboard(true);

          // Force page to load after [x-amount-of-time]
          if (vm.$store[`${page}-timer`]) {
            clearTimeout(vm.$store[`${page}-timer`]);
          }
          vm.$store[`${page}-timer`] = setTimeout(() => {
            vm.setPageLoaded({ key: page, value: false });
          }, 28800000);
        } catch (error) {
          vm.setPageLoaded({ key: page, value: false });
          vm.setPageLoading({ key: page, value: false });
        }
      }
    }
  }
};
